import { Breadcrumb } from '@psyomics/ui-components';
import { Outlet } from 'react-router-dom';

const MobileLayout = () => (
  <div className="flex min-h-0 w-full flex-1 justify-center">
    <div className="mx-[16px] flex min-h-0 w-full min-w-0 flex-1 flex-col pb-6">
      <div className="form-container">
        <Breadcrumb />
      </div>
      <Outlet />
    </div>
  </div>
);

export { MobileLayout };
